import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { resolvePageTypeFromRoute } from '@classifieds-sell/shared';
import { Feedback, FeedbackService } from 'libs/datalayer/src';

@Component({
    selector: 'tm-feedback',
    templateUrl: './feedback-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FeedbackModalComponent {
    @Input() public listingId: number;
    @Input() public categoryId: number;
    @Input() public subCategory: string;
    @Input() public step: string;
    @Output() closeModal: EventEmitter<boolean> = new EventEmitter();

    public feedbackSentiment: string;
    public feedbackText: string;
    public submitted = false;

    @ViewChild('feedbackForm', { static: true }) public feedbackForm: NgForm;

    constructor(
        private _feedbackService: FeedbackService,
        private route: ActivatedRoute
    ) {}

    public submitFeedback(): void {
        if (this.feedbackText && this.feedbackText.length > 500) {
            return;
        }
        this.sendFeedback();
        this.submitted = true;
    }

    public onClose(): void {
        this.closeModal.emit();
    }

    private sendFeedback(): void {
        if (!this.feedbackSentiment && !this.feedbackText) {
            return;
        }

        const request = <Feedback>{
            categoryId: this.categoryId,
            subCategory: this.subCategory,
            sentiment: this.feedbackSentiment || 'unspecified',
            text: this.feedbackText || '',
            sellType: resolvePageTypeFromRoute(this.route, true),
            url: window.location.href,
            step: this.step,
            listingId: this.listingId
        };

        this._feedbackService.submitFeedback(request).subscribe();
    }
}
